@if (showBanner()) {
  <div class="cookie-consent-banner" [class.closing]="closingBanner()">
    <div class="banner-content">
      <h3>Your privacy matters to us.</h3>
      <p>
        We use cookies to make Knowzilla work and to understand how you use our platform. Essential cookies are always on. We also use Analytics
        cookies (via PostHog, hosted in the EU) to improve our product, but we will not set these unless you enable them.
      </p>
      <p>For more details, please read our <a routerLink="/privacy-policy">Privacy Policy</a>.</p>
    </div>
    <div class="banner-actions">
      <button class="primary-button" (click)="accept()">Accept All</button>
      <button class="secondary-button" (click)="reject()">Reject Non-Essential</button>
      <button class="link-button" (click)="openSettings()">Cookie Settings</button>
    </div>
  </div>
}

@if (showSettings()) {
  <div class="cookie-settings-modal" [class.closing]="closingModal()">
    <div class="modal-content">
      <i class="pi pi-times close-btn" (click)="closeSettings()" (keydown.enter)="closeSettings()" tabindex="0" role="button"></i>
      <h3>Cookie Settings</h3>
      <div class="setting">
        <div class="setting-header">
          <h4>Strictly Necessary</h4>
          <span class="badge">Always Active</span>
        </div>
        <p>These cookies are required for the website to function (e.g., logging in, secure sessions).</p>
      </div>
      <div class="setting">
        <div class="setting-header">
          <h4>Analytics (PostHog)</h4>
          <div class="toggle-switch">
            <input type="checkbox" id="analytics-toggle" [checked]="analyticsEnabled()" (change)="toggleAnalytics()" />
            <label for="analytics-toggle"></label>
          </div>
        </div>
        <p>These cookies help us understand which features are used most so we can improve the Knowzilla experience.</p>
      </div>
      <div class="modal-actions">
        <button class="primary-button" (click)="saveSettings()">Save Settings</button>
      </div>
    </div>
  </div>
}
